export const keepNumbersAndPlusSymbolOnly = (s?: any) => (s + '').replace(/[^\d+]/g, '');

export const hasIrishCountryCode = (s?: any) => (s + '').match(/^(\+?)353/);

export const formatAsIrishNumber = (s?: any) => {
  if (!hasIrishCountryCode(s)) return s;
  const a = keepNumbersAndPlusSymbolOnly(s);
  return a.replace(/^(\+?)353(0?)/, "+353");
}